import { useEffect, useRef, useState } from 'react';

interface CarouselScrollTrackProps {
  className?: string;
  children: React.ReactNode;
}

export function CarouselScrollTrack({ className = '', children }: CarouselScrollTrackProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => {
      const canScroll = el.scrollWidth > el.clientWidth + 4;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
      setShowHint(canScroll && !atEnd);
    };
    update();
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      el.removeEventListener('scroll', update);
      ro.disconnect();
    };
  }, [children]);

  return (
    <div className="carousel-track-wrap">
      <div ref={ref} className={className}>
        {children}
      </div>
      {showHint && (
        <div className="carousel-scroll-hint" aria-hidden>
          <span className="carousel-scroll-arrow">›</span>
        </div>
      )}
    </div>
  );
}
